import React, { useState } from "react";
import { format, subDays } from "date-fns";
import storage from "../../../Services/Storage";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import * as Fa from "react-icons/fa";
import { EndpointStkAdjReport, createAPIEndpointStkAdjReport } from "../../../Services/stockreport/StockAdjustmentReport";
import { Calendar } from "primereact/calendar";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";

const StockAdjustmentReport = () => {
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);

    const handleExportExcel=(fromDate,toDate)=>
    {
        const auth = storage.getLocal("user");
        setLoadingExcel(true);
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let uniqueNo = `StockaAdjustmentData${GetDateFormat()}`;
        createAPIEndpointStkAdjReport()
            .get(`${EndpointStkAdjReport.GetStockAdjustmentExcel}?strFromDateString=${fromDateRange}&strToDateString=${toDateRange}&CompId=${auth.CompId}`)
            .then((val) => {
                if(val.data.length>0){
                    var wb = XLSX.utils.book_new();
                    let MapData = val.data.map((val) => {
                        var dateString = val["Document Date"];
                        var newData = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
                        var data = new Date(newData);
                        return { ...val, "Document Date": data};
                    });
                    var ws = XLSX.utils.json_to_sheet(MapData);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                }
                else{
                    toast.warning(
                        "No data found between these dates",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                }
                setLoadingExcel(false);
            }).catch((err)=>{
                toast.error(
                    `${err.data}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }
                );               
                setLoadingExcel(false);
            });
    };
    

    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">Stock Adjustment Report to Excel</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={()=>{handleExportExcel(fromDate,toDate);}}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Save As Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );

    
    
};

export default StockAdjustmentReport;